export enum ApiPaths {
    Auth = 'auth',
    PollUserLastChange = 'poll_user_last_change',
    RequestUpdatedUser = 'request_updated_user',
    RecoverLostUsername = 'recover_lost_username',
    RecoverLostPassword = 'recover_lost_password',
    RecoverEmergencyCode = 'recover_emergency_code',
    LockIdentity = 'lock_identity',
    ActivateSpid = 'activate_spid',
    SendOtp = 'send_otp',
    changePasswordWithOTP = 'modify_password_otp',
    SetPassword = 'set_password',
    ChangeEmail = 'change_email',
    ChangeEmailNotifications = 'toggle_email_notifications',
    ChangePhoneNumber = 'change_phone_number',
    ChangeAddress = 'update_address',
    ChangeDigitalAddress = 'update_digital_address',
    ChangeDocument = 'update_identity_document',
    ChangeCompany = 'change_company',
    SuspendIdentity = 'suspend_identity',
    ReactivateIdentity = 'reactivate_identity',
    GetAccessLogs = 'get_access_logs',
    ResetPassword = 'reset_password',
    RevokeIdentity = 'revoke_identity',
    ConfirmEmail = 'confirm_email',
    LookUpNameDoc = 'get_document_issuer',
    LookUpCountry = 'get_countries',
    LookUpProvinces = 'get_provinces',
    LookUpCity = 'get_cities',
    GetContract = 'get_contract',
    ResendConfirmationEmail = 'resend_confirmation_email',
    Drafts = 'drafts',
    CreateDraft = 'create_draft',
    CancelDraft = 'cancel_draft',
    CompileDraft = 'create_company_request',
    Requests = 'company_requests',
    CancelRequest = 'cancel_request',
    ApproveRequest = 'approve_request',
    EnrollRequest = 'enroll_request',
    AddDocument = 'add_document',
    CheckEmail = 'check_email',
    DownloadEidupContract = 'download_eidup_contract',
    AuthenticateAutologin = 'auth/autologin',
    AutologinQrcode = 'auth/autologin/qrcode',
}
